var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,128c0-35.3,28.7-64,64-64h149.5c17,0,33.3,6.7,45.3,18.7l106.5,106.6c12,12,18.7,28.3,18.7,45.3v277.4c0,35.3-28.7,64-64,64H192c-35.3,0-64-28.7-64-64V128ZM336,122.5v93.5c0,13.3,10.7,24,24,24h93.5l-117.5-117.5ZM248,320c-13.3,0-24,10.7-24,24s10.7,24,24,24h144c13.3,0,24-10.7,24-24s-10.7-24-24-24h-144ZM248,416c-13.3,0-24,10.7-24,24s10.7,24,24,24h144c13.3,0,24-10.7,24-24s-10.7-24-24-24h-144Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.3799c2ead811c278015c290c1e01da54.svg";
export { ForwardRef as ReactComponent };